"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateNumberFormat = void 0;
var math_1 = require("../math");
var constant_1 = require("../constant");
// 暂时先从原函数中引入
var FormatUtils_1 = require("../../utils/FormatUtils");
/**
 * 根据解析出的数字格式字符串计算对应的数值
 * @param value 用户输入的数值
 * @param tokenizedList 分词后得到的数组
 * @param context 解析需要的环境变量, 由分词过程得到
 */
function calculateNumberFormat(value, tokenizedList, context) {
    // 获取环境变量
    var parsedNumberString = context.parsedNumberString, needCutEndPercentageLabel = context.needCutEndPercentageLabel, numberFormatTokenIndexes = context.numberFormatTokenIndexes, formatListLength = context.formatListLength;
    // 返回变量
    var outputString;
    var valueToWrite;
    // 计算应该展示的数值
    if (parsedNumberString.charCodeAt(0) === 40) {
        // 首位为 '(' 时特殊处理
        outputString = FormatUtils_1.write_num(constant_1.TokenType.LeftParenthesis, parsedNumberString, value);
    }
    else {
        valueToWrite = Number(value) < 0 && formatListLength > 1 ? math_1.positiveNumberOrString(value) : value;
        outputString = FormatUtils_1.write_num(constant_1.TokenType.Number, parsedNumberString, valueToWrite);
    }
    // 如果需截掉末尾的百分比符号
    if (needCutEndPercentageLabel && (outputString === null || outputString === void 0 ? void 0 : outputString.endsWith('%'))) {
        outputString = outputString.substr(0, outputString.length - 1);
    }
    // 若分词数组仅有一个数值类型, 直接将计算得到的数值赋给它
    if (numberFormatTokenIndexes.length === 1) {
        var numberIndex = numberFormatTokenIndexes[0];
        tokenizedList[numberIndex].value = outputString;
        return;
    }
    // 剩余针对有多个数值类 token 存在的情况, 例如 '#\a#', '0\.0' 等用 \x 来分割的格式串
    HandleMultiNumberFormat(tokenizedList, outputString, numberFormatTokenIndexes);
}
exports.calculateNumberFormat = calculateNumberFormat;
/**
 * 针对有多个数值类 token 存在时的处理函数
 * @param tokenizedList 分词后得到的数组
 * @param outputString 根据完整数值格式解析得到的最终值
 */
function HandleMultiNumberFormat(tokenizedList, outputString, numberFormatTokenIndexes) {
    var outputSringIndex = outputString.length;
    var outputSringLastIndex = outputSringIndex;
    var tokenListIndex = numberFormatTokenIndexes.length - 1;
    // 从数值分词下标数组末尾开始将输出值进行分配
    while (tokenListIndex >= 1 && outputSringIndex) {
        var numbertokenIndex = numberFormatTokenIndexes[tokenListIndex];
        var tokenValue = String(tokenizedList[numbertokenIndex].value);
        // 对数值分词与输出值进行匹配
        outputSringIndex -= Math.min(tokenValue.length, outputSringLastIndex);
        // 截取对应的输出值 赋值给对应分词值
        tokenizedList[numbertokenIndex].type = constant_1.TokenType.Text;
        tokenizedList[numbertokenIndex].value = outputString.substring(outputSringIndex, outputSringLastIndex);
        tokenListIndex -= 1;
        outputSringLastIndex = outputSringIndex;
    }
    // 判断循环终止时只剩下第一位数值分词, 直接将剩余的数值赋值
    if (tokenListIndex === 0) {
        var numbertokenIndex = numberFormatTokenIndexes[0];
        tokenizedList[numbertokenIndex].type = constant_1.TokenType.Text;
        tokenizedList[numbertokenIndex].value = outputString.substring(0, outputSringLastIndex);
        return;
    }
    // 输出值提前分配完成此时将剩余的数值分词值赋为空
    while (tokenListIndex >= 0) {
        var numbertokenIndex = numberFormatTokenIndexes[tokenListIndex];
        tokenizedList[numbertokenIndex].type = constant_1.TokenType.Text;
        tokenizedList[numbertokenIndex].value = '';
        tokenListIndex -= 1;
    }
}
//# sourceMappingURL=calculation.js.map